import React, { useState } from "react";
import Cropper from "react-easy-crop";
import MDButton from "dashboard/components/MDButton";
import MDBox from "dashboard/components/MDBox";
import { Select, Slider, MenuItem, Grid, ButtonGroup,Icon, LinearProgress } from "@mui/material";
import getCroppedImg from "./cropImage";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const ROTATE_STEP = 15;
// const CONTAINER_HEIGHT  = 400;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
};

const aspectRatios = [
  { value: 3 / 4, text: "normal", reSize:{height: 2560, width:1920 }},
  { value: 1, text: "square", reSize:{height: 1000 , width: 1000 } },
  { value: 4 / 3, text: "wide",reSize:{height: 1512 , width: 2148 } },
  { value: 16 / 9, text: "16/9", reSize:{height: 1440 , width: 2560 } },
];

const ImageCropDialog = ({
  id,
  imageUrl,
  cropInit= { x: 0, y: 0 },
  zoomInit =1,
  rotateInit=0,
  aspectInit=aspectRatios[0],
  extension,
  onCancel,
  setCroppedImageFor,
  isLoading
}) => {

  const [zoom, setZoom] = useState(zoomInit);
  const [crop, setCrop] = useState(cropInit);
  const [aspect, setAspect] = useState(aspectInit);
  const [rotation, setRotation] = useState(rotateInit);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  
  const onCropChange = (cropped) => {
    setCrop(cropped);
  };

  const onZoomChange = (event, newValue) => {
    setZoom(newValue);
  };

  const onRotateChange = (event, direction) => {
    const newValue = direction === "right" ? rotation + ROTATE_STEP : rotation - ROTATE_STEP
    setRotation(newValue);
  };

  const onAspectChange = (e) => {
    const {value} = e.target;
    const ratio = aspectRatios.find((ratioAsp) => ratioAsp.value === value);
    setAspect(ratio);
  };

  const onCropComplete = (croppedArea, croppedAreaPixelsFor) => {
    setCroppedAreaPixels(croppedAreaPixelsFor);
  };

  const onCrop = async () => {
    const croppedImageUrl = await getCroppedImg(imageUrl, croppedAreaPixels, rotation, aspect.reSize, extension);
    setCroppedImageFor(id, crop, zoom, rotation, aspect, croppedImageUrl);
  };

  const onResetImage = () => {
    setAspect(aspectInit);
    setZoom(zoomInit);
    setRotation(rotateInit);
    setCrop(cropInit);
  };

  return (
    <MDBox>
      <Grid container justifyContent="center" className="controls">
      {isLoading && <LinearProgress color="info"   sx={{ marginBottom:"15px", width:"100%", overflowX:"hidden"}} />}    
        <Grid item xs={12} className="controls-upper-area">
          <Slider
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange = {e => onZoomChange(e, e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          {/* eslint-disable */}
          <MDBox className="backdrop"></MDBox>
          <MDBox className="crop-container" sx={{ position: "relative", minHeight:"300px"}}>
            <Cropper
              image={imageUrl}
              zoom={zoom}
              zoomSpeed={4}
              maxZoom={3}
              // zoomWithScroll={true}
              rotation={rotation}
              crop={crop}
              aspect={aspect.value}
              onCropChange={onCropChange}
              onZoomChange={onZoomChange}
              onRotateChange={onRotateChange}
              onCropComplete={onCropComplete}
              showGrid={false}
              onWheelRequest={e => false}
            />
          </MDBox>
        </Grid>
        <Grid container justifyContent="space-between" item sx={{ mt:2, p:1 }} xs={12} textAlign="center" className="button-area">
          <MDButton size="small" variant="gradient" onClick={onCancel} sx={{mr:1, mb:1}} color="light"  >Cancel</MDButton>
          <MDButton size="small" variant="gradient" onClick={onResetImage} sx={{mr:1, mb:1}} color="dark">Reset</MDButton>
          <MDButton size="small" variant="gradient" onClick={onCrop} sx={{mr:1, mb:1}} color="primary">Valider</MDButton>
          <ButtonGroup
            disableElevation
            variant="contained"
            aria-label="Disabled elevation buttons"
            sx={{ mr:1, maxheight:"35px"}}
            color="dark"
          >
            <MDButton sx={{minHeight:30, minWidth:30, p:.5, mb:1}} onClick={ e => onRotateChange(e,"left")}  variant="gradient"  color="dark"><Icon size="large">rotate_left</Icon></MDButton>
            <MDButton sx={{minHeight:30, minWidth:30, p:.5, mb:1}} onClick={ e => onRotateChange(e,"right")} variant="gradient" color="dark"><Icon size="large">rotate_right</Icon></MDButton>
          </ButtonGroup>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={aspect.value}
            label="Aspect ratio"
            onChange={onAspectChange}
            MenuProps={MenuProps}
            sx={{ minHeight:"45px"}}
            size="small"
            >
            {aspectRatios.map((ratio) => (
              <MenuItem key={ratio.text}
                    value={ratio.value}
                    selected={ratio.value === aspect.value}>
                    {ratio.text}
              </MenuItem>
            ))}
          </Select>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default ImageCropDialog;